import credentialsService from './credentialsService';

export default {
  logout() {
    // Remove auth data that we store in storage
    credentialsService.removeAuthBody();

    // Do a hard reload
    window.location.href = '/login';
  },
};
